import withGS from './withGShoc';
import GS from '../grafsync/grafsync';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { globalStyles } from './style/gstheme';

const styles = Object.assign({
    iriChip: {
        color: 'white',
        marginRight: 10,
        marginBottom: 10,
        maxWidth: '100%'
    },
    iriChipLabel: {
        overflow: 'hidden',
        display: 'inline-block',
        textOverflow: 'ellipsis'
    }
}, globalStyles);

class EditedIriLink extends React.Component {

    handleDeleteLink = () => {
        // We do this directly to ensure direction of link delete is correct 
        GS.deleteProperty(this.props.source, this.props.graph, this.props.property, this.props.iri, null, null);
    };

    handleClick() {
        if (this.props.link) this.props.history.push(this.props.link);
    }

    render() {

        const { data, classes, icon, source, isReadOnly, dataTest } = this.props;

        const currentIRI = data.iri && data.iri.length > 0 ?
            data.iri[data.iri.length - 1]
            :
            data.id;

        const notAvailable = data._notAvailable;
        const deprecated = data.deprecated;

        return (
            <Tooltip
                PopperProps={{
                    "data-test": "id-tip"
                }}
                title={currentIRI}
                style={
                    {
                        ...(deprecated) && { backgroundColor: '#CA4F0C' }
                    }
                }>
                <Chip
                    data-test={dataTest}
                    color="primary"
                    avatar={icon ? <Avatar style={{ backgroundColor: '#01579B' }}>{icon}</Avatar> : null}
                    onClick={this.props.link && !notAvailable ? () => this.handleClick() : null}
                    onDelete={!isReadOnly && source ? this.handleDeleteLink : null}
                    label={currentIRI}
                    className={classes.iriChip}
                    classes={{
                        label: classes.iriChipLabel
                    }}
                />
            </Tooltip>
        );
    }
}

EditedIriLink.defaultProps = {
    isReadOnly: false
};

EditedIriLink.propTypes = {
    dataTest: PropTypes.string,
    isReadOnly: PropTypes.bool,
    link: PropTypes.string,
    iri: PropTypes.string,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    icon: PropTypes.object,
    source: PropTypes.string,
    property: PropTypes.string,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(withGS(EditedIriLink, ["ALL"], null, {}, true)));